import React from 'react';
import '../../../stylesheets/stylesLayout/cardHotelProperties.scss';
import Card from '../../../muiComponents/Card';
import LoadingPlaceholder from '../../../muiComponents/LoadingPlaceholder';

const CardPropertyShimmer = () => {
    return (
        <Card className='card__property__container'>
            <LoadingPlaceholder
                variant='rectangular'
                animation='wave'
                width={'100%'}
                height={'70%'}
                style={{ borderRadius: '7px 7px 0 0' }}
            />
            <LoadingPlaceholder animation='wave' style={{ margin: '12px' }} />
            <LoadingPlaceholder animation='wave' style={{ margin: '0 12px' }} />
        </Card>
    );
};

export default CardPropertyShimmer;
